module.exports = __webpack_public_path__ + "img/review2.2a6a8c14.png";